// extracted by mini-css-extract-plugin
export var active = "_eh-7";
export var container = "_eh-0";
export var evenWidth = "_eh-4";
export var large = "_eh-5";
export var outlet = "_eh-8";
export var slide = "_eh-2";
export var small = "_eh-6";
export var tab = "_eh-3";
export var tabs = "_eh-1";